import React from "react";
import { Helmet } from "react-helmet";
import { decode } from "html-entities";
import LazyLoadingImage from "@col-care/common/blocks/lazy-loading-image";

const FourZeroFour = (props) => {
  let pageContext = props.pageContext;

  const metaTitleSuffix =
    decode(pageContext?.site_config?.seo.meta_title) || "The Green Solution";
  const metaTitle = "Page Not Found | " + metaTitleSuffix;

  return (
    <div>
      <Helmet>
        <title>{`${metaTitle}`}</title>
      </Helmet>
      <div>
        <div
          style={{ textAlign: "center", paddingTop: "50px", color: "#375542" }}
        >
          <h2>Bummer!</h2>
          <LazyLoadingImage
            src="https://images.contentstack.io/v3/assets/bltc2a866f5b4786ae7/bltbb8f8aac39a565bf/630d820bb31aea583acf2393/kushtopher.png"
            aria-label="Bummer!"
          />
          <h1>Your requested page was not found.</h1>
        </div>
      </div>
    </div>
  );
};

FourZeroFour.displayName = "FourZeroFour";

export default FourZeroFour;
